export const formatToCurrency = (
  value?: string | number,
  decimalPoints?: number,
  notation: Intl.NumberFormatOptions['notation'] = 'standard',
  significantFigures?: number
) => {
  if (!value && value !== 0) return;

  const formatterOptions: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: 'USD',
    notation,
  };

  // If significantFigures is provided, use it
  if (typeof significantFigures === 'number') {
    formatterOptions.maximumSignificantDigits = significantFigures;
  } else {
    // Otherwise use decimal points (maintaining original behavior)
    formatterOptions.minimumFractionDigits = 0;
    formatterOptions.maximumFractionDigits = decimalPoints ?? 2;
  }

  const formatter = new Intl.NumberFormat('en-US', formatterOptions);

  return formatter.format(Number(value));
};

export const formatNumber = (value?: string | number, precision = 2) => {
  if (!value) return;

  const formatter = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: precision,
  });

  return formatter.format(parseFloat(String(value)));
};
